import React from 'react';
import { HeroPromoText, renderPromoText } from './HeroPromoText';

type Props = {
  message: string;
  variant?: 'hero' | 'card';
  title?: string;
  reason?: 'paused' | 'outside_hours';
};

export function OrdersPausedNotice({ message, variant = 'card', title, reason = 'paused' }: Props) {
  const badgeTitle =
    title ?? (reason === 'outside_hours' ? 'Currently closed' : 'Online orders paused');
  const icon = reason === 'outside_hours' ? 'bi-clock' : 'bi-pause-circle';

  if (variant === 'hero') {
    return <HeroPromoText text={message} />;
  }

  return (
    <div className="chunkzters-card p-4 p-md-5 text-center" role="status" aria-live="polite">
      <div className="mb-3">
        <span className="badge text-bg-warning px-3 py-2" style={{ fontSize: 13 }}>
          <i className={`bi ${icon} me-1`} aria-hidden />
          {badgeTitle}
        </span>
      </div>
      <div className="fw-semibold" style={{ fontSize: 18, lineHeight: 1.5 }}>
        {renderPromoText(message)}
      </div>
    </div>
  );
}
